// extracted by mini-css-extract-plugin
module.exports = {"Container":"AreaEffectEdit_Container__7VCOh","Background":"AreaEffectEdit_Background__3DBjr","Rotator":"AreaEffectEdit_Rotator__3C2N4"};